import { ActionTree, ActionContext } from 'vuex';
import { ApprovalApi } from '@/api/approval-api';
import { ApprovalFilters } from '@/models/approval-filters';
import { Mutations } from '@/stores/approvals/mutation-constants';
import { State } from '@/stores/approvals/state';
import { Forbidden } from '@/models/forbidden-error';
import { NotFound } from '@/models/not-found-error';
import router from '@/router';

const api = new ApprovalApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public fetchAsync = async (context: ActionContext<State, any>, filters: ApprovalFilters) => {
        try {
            const result = await api.fetchAsync(filters);
            context.commit(Mutations.SetAllApprovals, result.approvals);
            // context.commit(Mutations.SetCurrentPageSize, result.pageSize);
            context.commit(Mutations.SetAllApprovalsTotalPages, Math.ceil(result.total / ((result.pageSize < 1) ? 1 : result.pageSize)));
            context.commit(Mutations.SetAllApprovalsTotalApprovals, result.total);
        } catch (e) {
            if (e instanceof Forbidden) {
                router.push({ name: 'forbidden' });
            }
            if (e instanceof NotFound) {
                router.push({ name: 'not-found' });
            }
        }
    }
    public updateAllApprovalsFilterStatus = (context: ActionContext<State, any>, value: number | string | null) => {
        context.commit(Mutations.SetAllApprovalsFilterStatus, value);
    }
    public updateAllApprovalsPage = (context: ActionContext<State, any>, value: number) => {
        context.commit(Mutations.SetAllApprovalsPage, value);
    }
    public updateAllApprovalsFrom = (context: ActionContext<State, any>, value: string | null) => {
        context.commit(Mutations.SetAllApprovalsFrom, value);
    }
    public updateAllApprovalsTo = (context: ActionContext<State, any>, value: string | null) => {
        context.commit(Mutations.SetAllApprovalsTo, value);
    }
}
